import React from "react";
import { Link } from "react-router-dom";

const DeleteModal = ({ onConfirm, onCancel, Name }) => {
  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)", 
          zIndex: 1040, 
        }}
        onClick={onCancel} 
      ></div>

      <div
        className="modal custom-modal fade show"
        role="dialog"
        style={{ display: "block", zIndex: 1050 }} 
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{Name}</h3>
                <p>Are you sure you want to delete this?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                    <Link
                      to="#"
                      className="btn btn-primary continue-btn"
                      onClick={onConfirm} // Trigger the deletion logic
                    >
                      Delete
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link
                      to="#"
                      className="btn btn-primary cancel-btn"
                      onClick={onCancel} // Close the modal
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
};

export default DeleteModal;
